import { api } from "api/api";
import { AxiosError } from "axios";
import CentroCusto from "model/administracao/cadastro/centrocusto/CentroCusto";
import Usuario from "model/administracao/cadastro/Usuario";
import Page from "model/page/Page";
import Pageable from "model/page/Pageable";
import ViagemDespesa from "model/viagem/ViagemDespesa";
import ViagemDespesaAprovacao from "model/viagem/ViagemDespesaAprovacao";
import ViagemTipoDespesa from "model/viagem/ViagemTipoDespesa";
import { DataTableFilterMeta, DataTableOperatorFilterMetaData } from "primereact/datatable";
import { BaseServiceCadastros } from "service/BaseServiceCadastros";
import { getFilters } from "utils/filterUtils";

class ViagemDespesaAprovacaoService implements BaseServiceCadastros<ViagemDespesaAprovacao> {

    pesquisar(page: Pageable, filters?: DataTableFilterMeta | null) {
        return new Promise<Page>((resolve, reject): void => {
            let url = `/viagemDespesaAprovacao/pesquisar`;
            url += getFilters(filters);

            const params = {
                page: page.page,
                size: page.size,
                sort: page.sort,
            };

            api
                .get(url, { params })
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    consultar(id: number) {
        return new Promise<ViagemDespesaAprovacao>((resolve, reject): void => {
            api
                .get(`/viagemDespesaAprovacao/consultar/${id}`)
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    incluir(viagemDespesa: ViagemDespesaAprovacao) {
        return new Promise<ViagemDespesaAprovacao>((resolve, reject): void => { });
    }

    editar(viagemDespesa: ViagemDespesaAprovacao) {
        return new Promise<ViagemDespesaAprovacao>((resolve, reject): void => { });
    }

    excluir(id: number) {
        return new Promise<void>((resolve, reject): void => { });
    }

    rejeitar(id: number): Promise<void> {
        return new Promise<void>((resolve, reject): void => {
            api
                .post(`/viagemDespesaAprovacao/rejeitar/${id}`)
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }
    aprovar(id: number): Promise<void> {
        return new Promise<void>((resolve, reject): void => {
            api
                .post(`/viagemDespesaAprovacao/aprovar/${id}`)
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }
}

export default ViagemDespesaAprovacaoService;